import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateRegEdSubmissions } from './useRegEdSubmissionsQuery';

/**
 * Releasing AFTER the scheduled date lands the blog in `Completed` without publishing — the advisor
 * must set a fresh future date for it to go out.
 */
export const useRegEdBlogReleaseMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (blogPost: Api.IBlogPost) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			blogPostId,
			impersonationContext,
		}: {
			blogPostId: string;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<Api.IBlogPost>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `blog/${encodeURIComponent(blogPostId)}/releaseConditionalHold`,
				}),
				'POST',
				null
			),
		onError,
		onSuccess: (blogPost, { blogPostId }) => {
			invalidateRegEdSubmissions(blogPostId);
			onSuccess?.(blogPost);
		},
	});
};
